import { PaddedSurface as Surface } from "App/global-style";
import { ContactUsAlert } from "Components/Form/Alert";
import { RadioButton } from "Components/Form/RadioButton";
import { useTexts } from "Components/TextContext";
import {
  AlertTitle,
  OptionLabel,
} from "Components/TextContext/commonComponentEnums";
import { BonusTransfer } from "Store/interfaces/CompanyTransferSpecifications";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { CarProductDetailsFormValues } from "../interfaces";
import { FirstCarInsurance } from "./FirstCarInsurance";
import { HaveCarInsurance } from "./HaveCarInsurance";
import { BonusValue } from "./constant";

interface Props {
  formProps: FormikProps<CarProductDetailsFormValues>;
  texts: any;
  lang: TextLanguage;
}

export const Bonus = (props: Props): React.ReactElement => {
  const { getText } = useTexts();
  const { formProps } = props;

  const bonusTransfer = formProps.values.bonusPreOwnership;

  return (
    <>
      <Surface>
        <RadioButton
          id="bonusPreOwnership"
          name="bonusPreOwnership"
          label={getText("carform.label.bonuspreownership")}
          hint={getText("carform.hint.bonuspreownership")}
          options={[
            {
              id: "has-own-bonus",
              value: BonusTransfer.MY_OWN,
              label: getText(OptionLabel.BOOLEAN_YES),
              hint: getText("carform.hint.hasownbonus"),
            },
            {
              id: "has-no-bonus",
              value: BonusTransfer.NONE,
              label: getText(OptionLabel.BOOLEAN_NO),
            },
          ]}
          error={getError("bonusPreOwnership", formProps)}
        />
        {bonusTransfer === BonusTransfer.NONE && (
          <FirstCarInsurance formProps={formProps} />
        )}
        {bonusTransfer === BonusTransfer.MY_OWN && (
          <HaveCarInsurance {...props} />
        )}
      </Surface>
      {formProps.values.bonus === BonusValue.MALUS && (
        <ContactUsAlert
          title={getText(AlertTitle.CALL_US)}
          description={getText("carform.alertdescription.cantsellbonusonline")}
          alertId="bonusTooLow"
          variant="border"
          marginBottom="32px"
        />
      )}
    </>
  );
};
